// Paginamaten (mm) van het projectrapport en de boorprofielen-export: staand A4. De kop (met
// logo) staat boven MT, de voet onder PH - MB (zie stampPageHeader/-Footer in pdf-logo.js).
export const PAGE = { PW: 210, PH: 297, ML: 16, MR: 16, MT: 20, MB: 16 };
